<template>
  <CRow>
    <CCol>
      <div class="admin-profile__history">
        <div
          v-for="car in cars"
          :key="`car-${car.id}`"
          class="admin-profile__history-car"
        >
          <div class="admin-profile__history-image">
            <div class="admin-profile__history-image-wrap">
              <img :src="getCarUrl(car)">
            </div>
          </div>
          <a
            v-if="car.verified"
            class="admin-profile__history-title"
            :href="getCarLink(car)"
          >
            {{car.title}}
          </a>
          <div v-else class="admin-profile__history-title">{{car.title}}</div>
          <div class="admin-profile__history-verification">
            <CBadge 
              :color="getVerficationStateColor(car)"
            >
              {{getVerificationStatus(car)}}
            </CBadge>
            <div>{{getVerifiedDate(car)}}</div>
          </div>
          <div class="admin-profile__history-description">{{car.verificationDescription}}</div>
        </div>
      </div>
      <div v-if="hasMoreCars" class="admin-profile__load-more">
        <CButton :disabled="busy" variant="outline" color="info">
          Load More
        </CButton>
      </div>
    </CCol>
  </CRow>
</template>

<script>
import {
  managersManagerStore,
  createManagersManagerMixin
} from '@/mixins/managersManagerMixin'
import { 
  getVerificationStatus,
  getVerficationStateColor
} from '@/utils/validation/car'
import timeFormat from '@/utils/time/timeFormat'
import URLS from '@/constants/url'
import { getAuctionLink } from '@/utils/helper'

const defaultImage = 'https://media.carsandbids.com/cdn-cgi/image/width=712,height=468,quality=70/da4b9237bacccdf19c0760cab7aec4a8359010b0/photos/3ja0R3IXGI2-2.lmFYrFQis.jpg?t=160323755351'

export default {
  name: 'TheAdminHistory',

  mixins: [createManagersManagerMixin()],

  created() {
    this[managersManagerStore.actionTypes.ACTION_GET_HISTORY]({ take: 50, skip: 0 })
  },

  beforeMount () {
    window.addEventListener('scroll', this.onPageScroll)
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.onPageScroll)
  },

  computed: {
    cars() {
      return this[managersManagerStore.getterTypes.GETTER_HISTORY]
    },
    loadedCarsCount() {
      return this.cars && this.cars.length
    },
    carsCount() {
      return this[managersManagerStore.getterTypes.GETTER_HISTORY_COUNT]
    },
    hasMoreCars() {
      return this.loadedCarsCount < this.carsCount
    }
  },

  data() {
    return {
      busy: false,
    }
  },

  methods: {
    onPageScroll() {
      const { scrollHeight, scrollTop, clientHeight } = document.documentElement
      if (!this.busy && this.hasMoreCars && clientHeight + scrollTop + 100 >= scrollHeight) {
        this.loadMoreCars()
      }
    },
    async loadMoreCars() {
      this.busy = true
      await this[managersManagerStore.actionTypes.ACTION_LOAD_MORE_HISTORY]({ take: 50, skip: this.loadedCarsCount })
      this.busy = false
    },
    getCarUrl(car) {
      return (car.carImages && car.carImages.length && car.carImages[0].url) || defaultImage
    },
    getVerifiedDate(car) {
      return car.verifiedDate && timeFormat(car.verifiedDate, 'MMMM DD, YYYY') || ''
    },
    getVerificationStatus(car) {
      return getVerificationStatus(car)
    },
    getVerficationStateColor(car) {
      return getVerficationStateColor(car)
    },
    getCarLink(car) {
      return `${URLS.app}${getAuctionLink(car)}`
    },
  }
}
</script>